import { Copy, SystemText } from 'e4shared';
import React from 'react';
import { withRouter } from 'react-router-dom';
import BlobImage from '../../../../components/blobImage';

export const Question = props => {
    const { data, history } = props;
    const st = (s, x) => SystemText(`Search/Results/Knowledge/${s}`, x);
    return (
        <div className="search-result box" onClick={() => history.push(`/knowledge-bank/${data.id}`)}>
            <div className="image-holder hidden-xs">
                <BlobImage folder="question_Image" src={data.image} partnerId={data.partner_Id} />
            </div>
            <div>
                <label className="label label-primary">
                    <i className="mr10 fa fa-bank" />
                    {st('Title')}
                </label>
                <h2>{data.name}</h2>
                <div>
                    <Copy value={data.summary} />
                </div>
                <span>
                    {data.extras1 === '1' ? `1 ${st('Answer')}` : `${data.extras1} ${st('Answers')}`}
                    {data.extras2 && <i className="ml10 fa fa-check text-success" title={st('Approved')} />}
                </span>
            </div>
        </div>
    );
};

export default withRouter(Question);
